<template>
  <div class="container">
    <el-pagination
      :page-size="params.pageSize"
      :current-page="params.PageNum"
      :page-sizes="[10, 20, 30, 40]"
      layout="total, sizes, prev, pager, next, jumper"
      :total="params.total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      background
    >
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    params: {
      type: Object,
    },
  },
  methods: {
    handleSizeChange(val) {
      this.$emit('changeSize', val);
    },
    handleCurrentChange(val) {
      this.$emit('changePage', val);
    },
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/style/mixins.less';
@import '~@/assets/style/var.less';
// 重写 element-ui 样式
.el-select .el-input__inner:focus {
  border-color: @primary-blue;
}
.page-num {
  width: 60px;
  font-size: 12px;
  /deep/.el-input__inner {
    height: 30px;
  }
}
.jump {
  display: inline-block;
  width: 54px;
  height: 30px;
  text-align: center;
  background: #f5f5f5;
  font-size: 12px;
  font-family: Helvetica Neue;
  font-weight: 400;
  color: #666;
  margin-left: 5px;
  cursor: pointer;
}
</style>
